import { useEffect } from 'react';
import { getStoredAnswers, storeAnswers } from '../../pages/Quiz/utils/quizSessionStorage';

/**
 * useQuizAnswers — persists user answers to localStorage and restores them on mount.
 *
 * @param {string} quizId - The quiz ID used as the localStorage key
 * @param {string} sessionId - The quiz session ID used to scope the answers key
 * @param {object} answers - The current answers state object
 * @param {function} setAnswers - State setter to restore saved answers on initial load
 * @param {boolean} [loaded=false] - Whether the quiz data has finished loading (to avoid restoring before data is ready)
 */
function useQuizAnswers(quizId, sessionId, answers, setAnswers, loaded = false) {
  // Restore saved answers from localStorage once quiz data is loaded
  useEffect(() => {
    if (!quizId || !loaded) return;

    const savedAnswers = getStoredAnswers(quizId, sessionId);
    if (savedAnswers) {
      setAnswers(savedAnswers);
    }
    // Only run once when loaded or sessionId becomes available and loaded is true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizId, sessionId, loaded]);

  // Persist answers to localStorage whenever they change
  useEffect(() => {
    if (quizId && Object.keys(answers).length > 0) {
      storeAnswers(quizId, sessionId, answers);
    }
  }, [quizId, sessionId, answers]);
}

export default useQuizAnswers;
